import { createSlice } from '@reduxjs/toolkit';

export const notificationPermissionDialogSlice = createSlice({
  name: 'notificationPermissionDialog',
  initialState: {
    isOpen: false,
    type: 'chat', // 'chat' or 'email'
  },
  reducers: {
    openNotificationPermissionDialog(state, action) {
      state.isOpen = true;
      state.type = action.payload?.type || 'chat';
    },
    closeNotificationPermissionDialog(state) {
      state.isOpen = false;
    },
  },
});

export const {
  openNotificationPermissionDialog,
  closeNotificationPermissionDialog,
} = notificationPermissionDialogSlice.actions;

export const selectNotificationPermissionDialog = (state) =>
  state.notificationPermissionDialog;
